import { Code20Regular } from '@/components/Icon'
import ActionButtonRow from './ActionButtonRow'
import styles from './HomePrimaryActions.module.scss'

export default function HomeCodePrimaryActions({
  onNewProject,
  newProjectActive = false,
}) {
  return (
    <div className={styles.group}>
      <ActionButtonRow
        Icon={Code20Regular}
        label="New Project"
        onClick={onNewProject}
        active={newProjectActive}
      />
    </div>
  )
}
